import isNil from 'lodash-es/isNil';
import { CLIENT_PREFIX } from '../../../resources/waterBalanceArvalis.type';
import { WEENAT_ARVALIS_CLIENT_ID } from './constants';
export const useArvalisClientIdFromOrg = (org) => {
    const clientId = isNil(org)
        ? undefined
        : org.networkType !== null
            ? org.id.toString()
            : org.subscribedNetworkId !== null
                ? org.subscribedNetworkId.toString()
                : WEENAT_ARVALIS_CLIENT_ID;
    return isNil(clientId) ? clientId : `${CLIENT_PREFIX}${clientId}`;
};
